import React from 'react';
import Autocomplete from '../common/AutoComplete';
import DepartmentAutocomplete from '../common/DepartmentAutocomplete';
import NamedAutocomplete from '../common/NamedAutocomplete';
import LoadingButton from '@mui/lab/LoadingButton';
import { useSelector, useDispatch } from 'react-redux';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useRef,useEffect, useState } from 'react';
import useAuth from '../../hooks/useAuth';
import store from '../../store';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';


function Inventoryreqeust() {

	const autocompleteElement = useRef('');
	const departmentAutocompleteElement = useRef('');
	// const activityAutocompleteElement = useRef('');

	//React.createRef();
	const SPARE_PART_REQUEST_URL="/Inventory/GetSpareParts";
	const SYNC_SPARE_PART_REQUEST_URL="/Inventory/SyncProducts";
	const SPARE_PART_DETAIL_REQUEST_URL="/Inventory/GetSparePart";
	const DEPARTMENT_REQUEST_URL="/Inventory/GetDepartmentPurposes";
	// const ACTIVITY_REQUEST_URL="/Inventory/GetActivities";
	const {auth,setAuth} = useAuth();
	const axiosPrivate = useAxiosPrivate();
	const errRef = useRef();
	const [errMsg, setErrMsg] = useState('');

	const inventoryRequestState = useSelector((state)=> state.value);
	
	const dispatch = useDispatch();

	const arrSuggestionsRedux = useSelector(() => store.getState().orderitem.SpareItems);

	//let arrSuggestions = [];
	const [arrSuggestions, setSuggestions] = useState([]);
	const [selectedSparePart, setSelectedSparePart] = useState([]);
	const [arrDepartments, setDepartments] = useState([]);
	const [arrPurposeSuggestions, setPurposeSuggestions] = useState([]);
	const [arrActivity, setActivity] = useState([]);
	const [isSendOpen, setSendOpen] = useState(false);

	//useEffect(()=>{userRef.current.focus()},[]);
    
	useEffect(() => {

		try{
            //console.log(`Bearer ${auth.accessToken}`)
            const response = axiosPrivate.get(SPARE_PART_REQUEST_URL,{
                withCredentials: true,
				params: {
				    location: auth.selectedLocation
				},
                headers: {
                  'content-type': 'application/json',
                  'Authorization': `Bearer ${auth?.accessToken}`
                  //'access-control-allow-origin' : '*'
                }
              })
              .then(response =>{
				
				//console.log(response.data);
                setSuggestions(response.data);
				dispatch({ type: 'addSpareItems', payload: {
					...state,
					'spareitems': response.data
				  }})
              })
              .catch(error =>{
                console.log(error);
              });
            
			const departmentResponse = axiosPrivate.get(DEPARTMENT_REQUEST_URL,{
                withCredentials: true,
                headers: {
                  'content-type': 'application/json',
                  'Authorization': `Bearer ${auth?.accessToken}`
                  //'access-control-allow-origin' : '*'
                }
              })
              .then(response =>{
				
				//console.log(response.data);
                setDepartments(response.data);
				dispatch({ type: 'addDepartmentPurposes', payload: {
					...state,
					'departmentPurposes': response.data
				  }})

              })
              .catch(error =>{
                console.log(error);
              });

			//   const activityResponse = axiosPrivate.get(ACTIVITY_REQUEST_URL,{
            //     withCredentials: true,
            //     headers: {
            //       'content-type': 'application/json',
            //       'Authorization': `Bearer ${auth?.accessToken}`
            //       //'access-control-allow-origin' : '*'
            //     }
            //   })
            //   .then(response =>{
				
			// 	//console.log(response.data);
            //     setActivity(response.data);
			// 	dispatch({ type: 'addActivities', payload: {
			// 		...state,
			// 		'activities': response.data
			// 	  }})

            //   })
            //   .catch(error =>{
            //     console.log(error);
            //   });
        }
        catch(err){

            console.log(err.response);

        }
		
	  }, []);

	
	const [isPurposeVisible, setPurposeVisible] = React.useState(false)  

	const [state, setState] = React.useState({
		//id: 0,
		sparePart: null,
		purpose: null,
		activity: null,
		location: auth.selectedLocation,
		aou:"",
		quantity:"",
		pickedBy:"",
	  });

	  useEffect(()=>{
		if(state.sparePart && state.sparePart["price"] == null) {
			setErrMsg('Price is not set for selected SKU.');
		} 
		else if(auth.selectedLocation == "Sanand" && state.sparePart && state.sparePart.sanandStock == 0) {
			setErrMsg('No stock available at Sanand.');
		} 
		else {
			setErrMsg('');
		}
      },[state.quantity,state.purpose,state.aou,state.pickedBy,state.sparePart]);

	  function handleChange(evt) {

		// console.log(autocompleteElement.current?.value);
		
		let value = evt.target.value;
		// if(evt.target.name.toLowerCase == 'quantity')
		// {
		// 	val=event.target.value.replace(/\D/g, '');
		// }
		setState({
		  ...state,
		  [evt.target.name]: value
		});
	  };

	function clear()
	{

		setState({
			sparePart: null,
			purpose: null,
			activity: null,
			location: auth.selectedLocation,
			aou:"",
			quantity:"",
			pickedBy:"",
		  });
		
		setPurposeVisible(false)
		autocompleteElement.current.resetState();
		departmentAutocompleteElement.current.resetState();
		// activityAutocompleteElement.current.resetState();
	};

	function updatePurposeSelection(purposeItem)
	{
		// console.log(`Purpose Value : ${purposeItem}`)
		setState({
			...state,
			'purpose': purposeItem,	
		  })
	}

	function updateSelection(item)
	{
		console.log(`UOM Value : ${item}`)
		setState({
			...state,
			'purpose': null,
			'location': auth.selectedLocation,
			'aou':"",
			'quantity':"",
			'pickedBy':"",
			'sparePart': null,
			'syncing': false,
			});

		if (item.sku.startsWith("ELEC")){
			setPurposeVisible(true);
			setPurposeSuggestions(arrDepartments.find(x=>x.name === "Electrical").purposes);
		} else if (item.sku.startsWith("LAB")){
			setPurposeVisible(true);
			setPurposeSuggestions(arrDepartments.find(x=>x.name === "Lab").purposes);
		} else if (item.sku.startsWith("Mech")){
			setPurposeVisible(true);
			setPurposeSuggestions(arrDepartments.find(x=>x.name === "Mechanical").purposes);
		} else {
			setPurposeVisible(false);
			setPurposeSuggestions([]);
		}

		const response = axiosPrivate.get(SPARE_PART_DETAIL_REQUEST_URL,{
			params: {
				sku: item.sku,
				location: auth.selectedLocation
			  },
			withCredentials: true,
			headers: {
			  'content-type': 'application/json',
			  'Authorization': `Bearer ${auth?.accessToken}`
			  //'access-control-allow-origin' : '*'
			}
		  })
		  .then(response =>{
			
			//console.log(response.data);
			setSelectedSparePart(response.data);
			dispatch({ type: 'addSpareItems', payload: {
				...state,
				'sparePart': response.data,
				'spareitems': response.data
			  }});
			  setState({
				...state,
				'purpose': null,
				'location': auth.selectedLocation,
				'aou':"",
				'quantity':"",
				'pickedBy':"",
				'sparePart': response.data
				});

			console.log("Price: ",response.data["price"]);
			if (item.sku.startsWith("ELEC")){
				setPurposeVisible(true);
				setPurposeSuggestions(arrDepartments.find(x=>x.name === "Electrical").purposes);
			} else if (item.sku.startsWith("LAB")){
				setPurposeVisible(true);
				setPurposeSuggestions(arrDepartments.find(x=>x.name === "Lab").purposes);
			} else if (item.sku.startsWith("Mech")){
				setPurposeVisible(true);
				setPurposeSuggestions(arrDepartments.find(x=>x.name === "Mechanical").purposes);
			} else {
				setPurposeVisible(false);
				setPurposeSuggestions([]);
			}
		  })
		  .catch(error =>{
			console.log(error);
		  });

		// departmentAutocompleteElement.current.resetState();
	}

	const onClearClick = (event) =>{
		clear();
	};

	function search(nameKey, myArray){
		for (let i=0; i < myArray.length; i++) {
			if (myArray[i].name === nameKey) {
				return myArray[i];
			}
		}
	}

	const onSyncClick = (event) => {
		setState({
			...state,
			'syncing': true,
		});
		const response = axiosPrivate.get(SYNC_SPARE_PART_REQUEST_URL,{
			withCredentials: true,
			headers: {
			  'content-type': 'application/json',
			  'Authorization': `Bearer ${auth?.accessToken}`
			  //'access-control-allow-origin' : '*'
			}
		  })
		  .then(response =>{
			
			//console.log(response.data);
			setSuggestions(response.data);
			dispatch({ type: 'addSpareItems', payload: {
				...state,
				'spareitems': response.data
			  }})
		  })
		  .catch(error =>{
			console.log(error);
		  })
		  .finally(()=> {
			setState({
				...state,
				'syncing': false,
			});
		  });
	}

	const onSendProductOpen = (event) => {
		setSendOpen(true);
	}

	const onSendProductClose = (event) => {
		setSendOpen(false);
	}

	const onAddClick = (event) => {
		//setValue(event.target.value);
		//console.log("click event firing");		
		//console.log(JSON.stringify(arrSuggestionsRedux.spareitems));		
		const suggestVal = state.sparePart;

		var isPurpose = suggestVal.sku.startsWith("ELEC") || suggestVal.sku.startsWith("LAB") || suggestVal.sku.startsWith("Mech");

		if(!suggestVal || !state.quantity || !state.aou || (isPurpose && !state.purpose) || !state.pickedBy)
		{
			setErrMsg('Please input mandatory fields');
			return false;
		}

		if(state.quantity < 1)
		{
			setErrMsg('Quantity cannot be less than 1');
			return false;
		}

		if(auth.selectedLocation == "Sanand" && state.quantity > state.sparePart.sanandStock)
		{
			setErrMsg('Quantity cannot be greater than '+state.sparePart.sanandStock);
			return false;
		}


		//String(document.getElementById('txtSuggest').value).replace(/&/g, '\&').replace(/</g, '\<').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); 
		//.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); 
		//console.log(`suggestVal : ${document.getElementById('txtSuggest').value}`);
		//console.log(`SpareItems : ${JSON.stringify(arrSuggestionsRedux.spareitems)}`);
		//console.log(`suggestVal : ${suggestVal}`);
		// const suggestSKU = arrSuggestionsRedux.spareitems.find(x=>x.name.replace(/\s/g,'') == suggestVal.replace(/\s/g,'')).sku;
		//const suggestUOM = arrSuggestionsRedux.spareitems.find(x=>x.name.replace(/\s/g,'') == suggestVal.replace(/\s/g,'')).uom;
		//search(suggestVal, arrSuggestionsRedux.spareitems);
		//arrSuggestionsRedux.spareitems.find(x=>x.name == suggestVal).sku
		//console.log(`suggestSKU : ${suggestSKU}`);
		setState({
			...state,
			// 'sku': suggestSKU,
			//'uom': suggestUOM,
			'sparePart.name': String(suggestVal.name).replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"')
		  });

		 //console.log(state);

		dispatch({ type: 'addorderitem', payload: {
			...state,
			// 'sparePart': this.state.sparePart,
			//'uom': suggestUOM,
			// 'name': String(suggestVal).replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"')
		  }})

		//console.log(store.getState().orderitem.neworderitems);
		clear();
		
		//console.log("click event fired");
	  };


  return (
    <><form>
		<div className="mb-3 row">
        <p ref={errRef} className={errMsg?'validation':"offscreen"} aria-live='assertive'>{errMsg}</p>
        </div>
		  <div className="mb-3 row">
			  <label className="col-sm-1 col-form-label">Item *</label>
			  <div className="col-sm-3">
				  {/* <input type="text" className="form-control" id="inputItem" />
				  <div className="position-absolute invisible" id="inputItem_complete"></div> */}
				   <Autocomplete
						suggestions={arrSuggestions} ref={autocompleteElement} change={updateSelection}
					/>
			  </div>
			  <div className="col-sm-3">
			  	  <LoadingButton className="btn btn-primary" fullWidth loading={state.syncing} variant="contained" onClick={onSyncClick}>Sync Products</LoadingButton>
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputSKU" className="col-sm-1 col-form-label">SKU *</label>
			  <div className="col-sm-3">
				  <input type="text" name="sku" className="form-control" value={state.sparePart ? state.sparePart.sku : ''} id="inputSKU" readOnly/>
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputUOM" className="col-sm-1 col-form-label">UOM *</label>
			  <div className="col-sm-3">
				  <input type="text" name="uom" className="form-control" value={state.sparePart ? state.sparePart.uom : ''} id="inputUOM" readOnly/>
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputQuantity" className="col-sm-1 col-form-label">Quantity *</label>
			  <div className="col-sm-3">
				  <input type="number" name="quantity" className="form-control" onChange={handleChange} placeholder='Enter Quantity' value={state.quantity} id="inputQuantity" />
				  <div style={{display: (state.sparePart) ? 'flex' : 'none'}} className='col float-end'><strong>Stock</strong>&nbsp;Sanand:&nbsp;{state.sparePart ? state.sparePart.sanandStock??'0' : '0'},&nbsp;Changodar:&nbsp;{state.sparePart ? state.sparePart.changodarStock??'0' : '0'}&nbsp;</div>
			  </div>
			  {/* <div className="col-sm-3">
			  	  <LoadingButton className="btn btn-primary" fullWidth loading={state.syncing} variant="contained" onClick={onSendProductOpen}>Send Product</LoadingButton>
		  	  </div> */}
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputActivity" className="col-sm-1 col-form-label">Activity *</label>
			  <div className="col-sm-3">
			  <input type="text" name="activity" className="form-control" value={state.sparePart && state.sparePart.category && state.sparePart.category.activity ? state.sparePart.category.activity.name: ''} id="inputActivity" readOnly/>
			  		{/* <NamedAutocomplete
						suggestions={arrActivity} ref={activityAutocompleteElement} change={updateActivitySelection}
					/> */}
				  {/* <input type="text" name="purpose" className="form-control" onChange={handleChange} value={state.purpose} id="inputPurpose" /> */}
			  </div>
		  </div>
		  <div className="mb-3 row" style={{display: (isPurposeVisible) ? 'none' : 'flex'}}>
			  <label htmlFor="inputCategory" className="col-sm-1 col-form-label">Category *</label>
			  <div className="col-sm-3">
				  <input type="text" name="category" className="form-control" value={state.sparePart && state.sparePart.category ? state.sparePart.category.name: ''} id="inputCategory" readOnly/>
			  </div>
		  </div>
		  <div className="mb-3 row" style={{display: (isPurposeVisible) ? 'flex' : 'none'}} >
			  <label htmlFor="inputPurpose" className="col-sm-1 col-form-label">Purpose *</label>
			  <div className="col-sm-3">
			  		<DepartmentAutocomplete
						suggestions={arrPurposeSuggestions} ref={departmentAutocompleteElement} change={updatePurposeSelection}
					/>
				  {/* <input type="text" name="purpose" className="form-control" onChange={handleChange} value={state.purpose} id="inputPurpose" /> */}
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputUse" className="col-sm-1 col-form-label">Area of Use *</label>
			  <div className="col-sm-3">
				  <input type="text" name="aou" className="form-control" onChange={handleChange} value={state.aou} id="inputUse" />
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputReciever" className="col-sm-1 col-form-label">Recieving Person *</label>
			  <div className="col-sm-3">
				  <input type="text" name="pickedBy" className="form-control" onChange={handleChange} value={state.pickedBy} id="inputReciever" />
			  </div>
		  </div>
		  <div className="mb-3 row">

			  <div className="col-sm-4">
				  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
					  <button className="btn btn-warning me-md-2" onClick={onClearClick} type="button">Clear</button>
					  <button className="btn btn-primary" type="button" onClick={onAddClick}>Add</button>
				  </div>
			  </div>
		  </div>

		  {isSendOpen && (
				<Dialog open={isSendOpen} onClose={onSendProductClose}>
				<DialogTitle>Confirm Delete</DialogTitle>
				<DialogContent>
					<Typography>Are you sure you want to delete this employee?</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={onSendProductClose}>Cancel</Button>
					<Button onClick={onSendProductClose} variant="contained" color="secondary">
					Delete
					</Button>
				</DialogActions>
				</Dialog>
			)}

	  </form>
	  
	  </>
  )
}

export default Inventoryreqeust